import { useCopilotAction } from '@copilotkit/react-core'

import { F0BookAMeetingCard } from '@factorialco/f0-react'

/**
 * Renders the "Talk with an expert" card. Visual frontend tool — no handler,
 * the agent emits it and the card handles the user click.
 */
export const useBookAMeetingCardAction = () => {
  useCopilotAction({
    name: 'AiWidgets.UpsellKit.F0BookAMeetingCard',
    description:
      "Display a card to book a meeting with experts: avatars, title (e.g. 'Talk with an expert'), schedule (e.g. 'Mon-Fri · 09:00-21:00 (CEST)'), and a primary action button (e.g. 'Book a meeting').",
    parameters: [
      {
        name: 'actionHref',
        type: 'string',
        description: 'Optional URL for the action button (e.g. booking page)',
        required: false,
      },
      {
        name: 'avatars',
        type: 'object[]',
        description: 'Optional list of expert avatars. Each object: { firstName, lastName, src? }',
        required: false,
        attributes: [
          {
            name: 'lastName',
            type: 'string',
            description: 'Last name of the expert',
            required: true,
          },
          {
            name: 'src',
            type: 'string',
            description: 'Optional avatar image URL',
            required: false,
          },
        ],
      },
    ],
    available: 'frontend',
    followUp: false,
    render: ({ args: { actionHref } }) => (
      <F0BookAMeetingCard actionHref={actionHref} onAction={actionHref ? undefined : () => {}} />
    ),
  })
}
